<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close" (click)="close()">&times;</button>
    <h3
      class="modal-title"
      [textContent]="translate('consumer_newuser_header', 'Register new user')"
    ></h3>
  </div>
  <form (submit)="createUser()">
    <div class="modal-body">
      <div class="input-group">
        <label>
          {{translate('consumer_newuser_username', 'User name')}}
          <input
            type="text"
            [(ngModel)]="username"
            class="form-control"
            autofocus
            required
            autocomplete="username"
            id="username"
          />
        </label>
      </div>
      <div class="input-group">
        <label>
          {{translate('consumer_newuser_password', 'Password')}}
          <input
            type="password"
            [(ngModel)]="password"
            class="form-control"
            autofocus
            required
            id="new-password"
            autocomplete="new-password"
          />
        </label>
      </div>

      <div class="input-group">
        <label>
          {{translate('consumer_newuser_name', 'Name')}}
          <input
            type="text"
            [(ngModel)]="name"
            class="form-control"
            autofocus
            required
            id="name"
            autocomplete="name"
          />
        </label>
      </div>

      <div class="input-group">
        <label>
          {{translate('consumer_newuser_email', 'Email address')}}
          <input
            type="email"
            [(ngModel)]="email"
            class="form-control"
            autofocus
            required
            id="email"
            autocomplete="email"
          />
        </label>
      </div>
    </div>

    <div class="modal-footer">
      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="isActive"
        (click)="createUser()"
      >
        {{translate('consumer_newuser_newUser', 'Create User')}}
      </button>
      <div *ngIf="showError">
        <div
          class="alert alert-warning"
          style="margin: 10px 0 0; text-align: left"
        >
          {{translate('consumer_newuser_error', 'Could not create user -
          username is already in use.')}}
        </div>
      </div>
    </div>
  </form>
</div>
